import { Component, OnInit } from "@angular/core";
import { NotificationService } from "@app/core/services/notification.service";
import { ClientUserUriBuilderParams, UserService } from "@app/core/services/user.service";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { User2FAComponentBase } from "./user-2fa";

@Component({
    selector: 'user-2fa-sms',
    templateUrl: './user-2fa-sms.component.html'
})
export class User2FASmsComponent extends User2FAComponentBase implements OnInit {
   
    tan = '';
    showCodeVerifySection = false;

    constructor(
        protected userService: UserService,
        protected notificationService: NotificationService) {
        
        super(userService, notificationService);

        this._idPrefix = 'user-management.twoFa.sms';
    }

    public ngOnInit(): void {
    }

    protected resetInternal() {
        this.tan = '';
    }

    public sendVerificationCode(phoneNumber: string): void {
        const uriBuilder = new ClientUserUriBuilderParams(this.client, this.user);

        this.userService.setupTwoFAWithSms(uriBuilder, phoneNumber)
            .subscribe(result => {
                this.showCodeVerifySection = true;
            }, err => {
                if (err && err.error && err.error.additional_code === 'authentication.validation.sms.invalid.phonenumber') {
                    this.notificationService.showSimpleErrorSnackbar(marker('user_management.2fa.error.invalid_phonenumber'));
                }
            });
    }
}